import { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Close, Collections } from "@mui/icons-material";
import DocumentPreview from "components/_refactor/document-preview";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import LoadingData from "components/Loading/LoadingData";

export default function PhotosCatalog({ close, id }) {
  const [searching, setSearching] = useState(false);
  const [data, setData] = useState([]);

  const snackbar = useSnackbar();

  const handleSearch = async () => {
    setSearching(true);

    try {
      const response = await Api.get(
        "product-search-details",
        "product",
        "?idProduto=" + id,
        true
      );
      setData(response.Result.ProdutoDetalhes.ListaFotos || []);
    } catch (error) {
      snackbar.showMessage("Erro ao buscar fotos do produto:", {
        severity: "error",
      });
    } finally {
      setSearching(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <Dialog open onClose={close} maxWidth={"md"}>
      <DialogTitle>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h3" color="primary">
            <Collections style={{ marginRight: "12px" }} />
            Catálogo de Fotos
          </Typography>
          <IconButton onClick={close}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      {searching ? (
        <DialogContent>
          <LoadingData searching label="Buscando fotos do produto..." />
        </DialogContent>
      ) : (
        <DialogContent>
          <Grid container spacing={4}>
            {data?.length > 0 &&
              data?.map((item) => (
                <Grid key={item?.NomeMidia} item xs={12} md={4} lg={3}>
                  <DocumentPreview url={item?.Url} style={{ borderRadius: "10px" }} />
                </Grid>
              ))}
          </Grid>
        </DialogContent>
      )}
      <DialogActions>
        <Button variant="contained" color="primary" onClick={close}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
